import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

const DEFAULT_COLORS = [
  '#4e79a7',
  '#f28e2b',
  '#e15759',
  '#76b7b2',
  '#59a14f',
  '#bab0ab',
];

/**
 * HorizontalBarChart — 탑N 가로 막대 차트.
 * 사용법: docs/modules/frontend/HorizontalBarChart.md
 */
const HorizontalBarChart = ({
  data,
  title,
  width = 400,
  height = 300,
  topN,
}) => {
  const safeData = Array.isArray(data) ? data : [];

  if (safeData.length === 0) {
    return (
      <div
        style={{
          width,
          height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span>표시할 데이터가 없습니다</span>
      </div>
    );
  }

  // 1) value 내림차순 정렬
  const sorted = [...safeData].sort((a, b) => b.value - a.value);

  // 2) topN 명시 시에만 상위 N 개로 슬라이스 ("기타" 그룹화 없음 — DonutChart 와 차별).
  //    topN 미지정 → 받은 데이터(정렬만) 그대로 렌더 (backend 가 이미 가공한 경우 = 단일 진실 소스).
  const chartData =
    Number.isFinite(topN) && topN > 0 ? sorted.slice(0, topN) : sorted;

  return (
    <div
      style={{ width, height }}
      data-testid="hbar-root"
      data-layout="vertical"
    >
      {title ? (
        <div style={{ textAlign: 'center', fontWeight: 600 }}>{title}</div>
      ) : null}
      {/* 테스트 가시성을 위한 마커 (jsdom 에서 BarChart svg 가 비어도 활용) */}
      <div style={{ display: 'none' }} aria-hidden="true">
        {chartData.map((d) => (
          <span
            key={d.label}
            data-testid="hbar-row"
            data-label={d.label}
            data-value={d.value}
          />
        ))}
      </div>
      <ResponsiveContainer width="100%" height={title ? height - 24 : height}>
        <BarChart
          layout="vertical"
          data={chartData}
          margin={{ top: 8, right: 16, bottom: 8, left: 16 }}
        >
          <XAxis type="number" />
          <YAxis type="category" dataKey="label" width={80} />
          <Tooltip />
          <Bar dataKey="value" isAnimationActive={false}>
            {chartData.map((entry, idx) => (
              <Cell
                key={entry.label}
                fill={DEFAULT_COLORS[idx % DEFAULT_COLORS.length]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HorizontalBarChart;
